import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'

import favoriteIcon from '../_assets/favorite.svg'
import favoriteToggleIcon from '../_assets/favorite-toggle.svg'

import logic from '../profile-header/logic'

const FavoriteButton = () => {
  const { isInWishlist, isToggling } = useValues(logic)
  const { toggleWishlistStatus } = useActions(logic)

  const handleOnClick = event => {
    event.stopPropagation()
    toggleWishlistStatus()
  }

  return (
    <div className={`favorite-button${isToggling ? ' toggling' : ''}`} onClick={handleOnClick}>
      <img
        className={`favorite-icon${isToggling ? ' toggling' : ''}`}
        alt='favorite button'
        src={`${isInWishlist ? favoriteToggleIcon : favoriteIcon}`}
        width={17}
        height={15}
      />
    </div>
  )
}

export default FavoriteButton
